module.exports = __webpack_public_path__ + "img/cover-aygaz-step-into-the-future.9cc46921.png";